module.exports = __webpack_public_path__ + "img/circle-w.77bfd4b2.svg";